import { BackToTop } from './BackToTop.js'
import { Clipboard } from './Clipboard.js'
import { OffcanvasSwipe } from './OffcanvasSwipe.js'
import { ScrollAnim } from './ScrollAnim.js'

export class BlazorBody {
	OffcanvasSwipe: OffcanvasSwipe
	BackToTop: BackToTop
	ScrollAnim: ScrollAnim
	Clipboard: Clipboard

	constructor() {
		this.OffcanvasSwipe = new OffcanvasSwipe()
		this.BackToTop = new BackToTop()
		this.ScrollAnim = new ScrollAnim()
		this.Clipboard = new Clipboard()
	}
}

(window as any).BlazorBody = new BlazorBody()
